import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'

const ZRead = z.object({
  readingTime: z.string().nullable(),
  count: z.number().nullable()
})

const ZReadingcimCodeIds = z.object({
  paraMeterId: z.string(),
  paraMeterName: z.string(),
  unit: z.string().nullable(),
  paraMeterReading: z.array(ZRead)
})

const ZIntervalReadingAssetData = z.object({
  deviceId: z.string(),
  deviceName: z.string(),
  paraMeterReadings: z.array(ZReadingcimCodeIds)
})

export const ZApiResponse = z.object({
  error: z.boolean(),
  http_status: z.number(),
  data: z.array(ZIntervalReadingAssetData)
})

export type AlertTrendRegisterDataAssetDashboard = z.infer<typeof ZReadingcimCodeIds>
export type AlertTrendRegisterAssetData = z.infer<typeof ZApiResponse>

export async function getAlertTrendRegisterDataAssetDashboard (
  startDate: string,
  endDate: string,
  graphName: string,
  requestParameter: any,
  intervalGroup: string,
  isdefault: boolean,
  onSuccess: (AssetPerformanceLineData: any, httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any
): Promise<void> {
  const url = `/asset-data-service/api/v1/udp/tiq/assets/data/interval/alertTrend/asset?startDate=${startDate}&endDate=${endDate}&graphName=${graphName}&intervalGroup=${intervalGroup}&isDefault=${isdefault.toString()}`
  interceptedAxios
    .post(url, requestParameter, {
      timeout: 20000,
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then((response) => {
      if (response.status === 200) {
        const parseResponse = ZApiResponse.safeParse(response.data)
        if (parseResponse.success) {
          if (response.data.data !== null && response.data.data !== undefined) {
            onSuccess(parseResponse.data.data, response.status)
          }
        } else {
          onFailure(parseResponse.error.message, response.status)
        }
      } else if (response.status === 204) {
        onFailure('No Content', response.status)
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        if (error.response.data !== undefined) {
          onFailure(error.response.data.error_message, error.response.status)
        } else {
          onFailure(error.response.statusText, error.response.status)
        }
      } else {
        onFailure('Network Failure', error.status)
      }
    })
}
